<template>
        <div class="small-basket-fee-progress">
            <svg class="small-basket-fee-progress__icon" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#fff" fill-opacity=".01" d="M0 0h24v24H0z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5h1.307l2.632 7.02-.888 2.664A1 1 0 007 16h13a1 1 0 100-2H8.387l.353-1.058 11.343-.946a1 1 0 00.898-.8l1-5A1 1 0 0021 5H6.443l-.507-1.351A1 1 0 005 3H3a1 1 0 000 2zm16 16a2 2 0 100-4 2 2 0 000 4zm-9-2a2 2 0 11-4 0 2 2 0 014 0z" fill="#009FCE"/></svg>
            <div class="small-basket-fee-progress__container">
                <label class="small-basket-fee-progress__message" v-html="basketFeeDisclaimer" />
                <progress class="small-basket-fee-progress__progress" :max="basketFeeLimit" :value="subtotal"></progress>
            </div>
        </div>
</template>

<script>
    export default {
        name: 'SmallBasketFeeProgress',
        props: {
            basketFeeLimit: Number,
            subtotal: Number,
            basketFeeDisclaimer: String,
        }
    }
</script>



<style lang="scss" scoped>
    @import "../assets/lib";

    @mixin progress-value {
        border-radius: 8px;
        background: #009FCE;
    }

    .small-basket-fee-progress {
        display: flex;
        width: 100%;
        min-height: 62px;
        border: 1px solid #ccc;
        border-radius: 2px;
        align-items: center;
        padding: 1rem;
        background: #fff;
        margin-bottom: 1rem;

        &__icon {
            min-width: 24px;
        }

        &__container {
            display: flex;
            align-items: center;
            width: 100%;
            margin-left: 1rem;
            margin-bottom: 0px;
            margin-right: 0;
            flex-wrap: wrap;

            @media screen and (min-width: $breakpoint-tablet) {
                flex-wrap: nowrap;
                margin-right: 2rem;
                max-height: 62px;
            }
        }

        &__message {
            color: #414142;
            margin-right: 0;
            font-size: 14px;

            @media screen and (min-width: $breakpoint-tablet) {
                margin-bottom: 0;
                margin-right: 5rem;
                font-size: 12px;
                white-space: nowrap;
            }
        }

        &__progress, &__progress::-webkit-progress-bar {
            background: #EEECEC;
            position: relative;
            border-radius: 8px;
            border: none;
            height: 8px;
            width: 100%;
        }

        &__progress::-moz-progress-bar {
            @include progress-value;
        }

        &__progress::-webkit-progress-value {
            @include progress-value;
        }
    }
</style>